export default {
  parameters: {
    landing_id: "LatQTC",
  },
  newDesign: true,
  title: "¡Recibe una clase gratuita de programación personalizada para tu hijo! | Kodland",
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    title:
      "Elige el mejor horario para una clase gratuita - ¡solo 6 preguntas!",
    subtitle:
      "✏️ Para niños de 8 a 17 años<br>💻 Crean sus primeros proyectos digitales con la ayuda de un profesional de TI<br>💬 Descubrimos los talentos de tu hijo de manera divertida<br>🌐 Solo necesitas un ordenador y conexión a internet<br>💙 Ya elegido por más de 100.000 padres",
    image: {
      url: "/welcome/coding_freetc_latam_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/coding_freetc_latam_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Reserva tu lugar 🔥 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
      answers: [
        "🔥 ¡Si!",
        "🤗 No. Lo hace solo para divertirse y eso está bien"
      ],
    },
    2: {
      question: "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
      answers: [
        "👍 No tiene conocimientos, debe estudiar lo básico",
        "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
        "🖥️ Nivel intermedio, quiere profundizar conocimientos",
        "🎮 Usa los dispositivos más que nada para juegos"
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/reviews-latam.png",
      subtitle: "Nos recomiendan padres de todo el mundo. Esperamos que pronto te unas a ellos 💙",
      button: "¡Vamos!",
    },
    4: {
      question:
        "¿Tienes una computadora de escritorio o portátil con la que tu hijo puedo estudiar?",
      answers: [
        "💻 Si",
        {
          answer: "☹️ No",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      button: "",
    },
    6: {
      title: "¡Felicitaciones! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    7: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title:
        "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    10: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    11: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
